import React from 'react'
import { Grid, Button, Typography, makeStyles} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewTwoToneIcon from "@mui/icons-material/ArrowBackIosNewTwoTone";

const useStyles = makeStyles(() => ({
	Typography: {
        padding: "1rem", textAlign: "justify",    lineHeight:"normal" 
	},
	
}));


export default function ShippingPolicy() {
    const navigate = useNavigate();
    const classes = useStyles();

  return (
    <Grid style={{ background: "#f1f1f1", height: "100vh" }}>
      <Grid
        style={{
          padding: "0.8rem",
          boxShadow: "0px 0px 9px",
          background: "white",
        }}
      >
        <Button
          onClick={() => {
            navigate(-1);
          }}
          style={{
            position: "absolute",
            left: 0,
          }}
        >
          <ArrowBackIosNewTwoToneIcon />
        </Button>
        <Typography variant="h5" style={{ fontWeight: "bold" }}>
        Shipping Policy
        </Typography>
      </Grid>
      <Grid style={{ padding: "1rem", marginTop: "1rem" ,maxHeight:"85vh",overflow:"scroll",scrollbarWidth:"none" }} >

        <Typography className={classes.Typography}  style={{paddingBottom:"0rem"}}>There is no Shipping Policy as the products/items are consumed at location and are not shipped to the customers.</Typography>

{/* <Typography className={classes.Typography}  style={{fontWeight:"bold",paddingBottom:"0rem"}}>Introduction: </Typography> */}



{/* <Typography className={classes.Typography} >
COTTON PLUS is committed to ensuring the safety and satisfaction of our customers. As part of our dedication to upholding high standards of quality and compliance, we have established this Non-Shipping Policy to outline the food items that are not eligible for shipping through our services in India. </Typography>

<Typography className={classes.Typography}  style={{fontWeight:"bold",paddingBottom:"0rem"}}>
Scope: 


</Typography>
<Typography className={classes.Typography}>The following products of food items are not eligible for shipping through our services in India. </Typography>

<Typography className={classes.Typography} style={{paddingBottom:"0rem"}}>Non-Eligible Food Items: </Typography>
<ul>
    <li>
        <Typography className={classes.Typography} style={{paddingBottom:"0rem"}}> <span style={{fontWeight:"bold"}}> Perishable Food Items:</span> Perishable food items, including fresh produce, dairy products, meats, and seafood, are not eligible for shipping due to the risk of spoilage, contamination, and food safety concerns during transit. </Typography> </li>

        <li>
        <Typography className={classes.Typography} style={{paddingBottom:"0rem"}}> <span style={{fontWeight:"bold"}}>Frozen Food Items:</span> Frozen food items requiring continuous refrigeration or frozen storage conditions are not eligible for shipping due to the logistical challenges of maintaining proper temperature control during transit.  </Typography> </li>

        <li>
        <Typography className={classes.Typography} style={{paddingBottom:"0rem"}}> <span style={{fontWeight:"bold"}}>Homemade or Unpackaged Food Items:</span> Food items prepared in non-commercial kitchens or without proper packaging and labeling are not eligible for shipping due to regulatory restrictions and concerns about food safety and quality.  </Typography> </li>

        <li>
        <Typography className={classes.Typography} style={{paddingBottom:"0rem"}}> <span style={{fontWeight:"bold"}}>Food Items with Limited Shelf Life:</span> Food items with a limited shelf life or expiration date that may expire before reaching the recipient are not eligible for shipping to ensure the quality and freshness of products upon delivery.  </Typography> </li>

        <li>
        <Typography className={classes.Typography} style={{paddingBottom:"0rem"}}> <span style={{fontWeight:"bold"}}>Food Items Prohibited by Law:</span> Food items prohibited by Indian law or regulations, including those containing unauthorized ingredients or additives, are not eligible for shipping.  </Typography> </li>
</ul>


<Typography className={classes.Typography}  style={{fontWeight:"bold",paddingBottom:"0rem"}}>Exceptions: </Typography>

<Typography className={classes.Typography}>
Exceptions to this Non-Shipping Policy may be considered on a case-by-case basis for specific food items with proper documentation, packaging, and compliance with regulatory requirements. Customers seeking exceptions must contact COTTON PLUS approval before initiating shipment. </Typography>


<Typography className={classes.Typography}  style={{fontWeight:"bold",paddingBottom:"0rem"}}>Conclusion: </Typography>

<Typography className={classes.Typography}>
By adhering to this Non-Shipping Policy, COTTON PLUS aims to maintain compliance with relevant regulations, uphold food safety standards, and ensure the integrity of our shipping services in India. </Typography>

<Typography className={classes.Typography}  style={{fontWeight:"bold",paddingBottom:"0rem"}}>Contact Information: </Typography>

<Typography className={classes.Typography}>
For inquiries or further information regarding our Non-Shipping Policy for food items in India, <a href='/contactus'>Contact us </a></Typography> */}


        </Grid>
        </Grid>
  )
}
